import React, { Component } from 'react';
import './StripePayments.scss';
//import scriptLoader from 'react-async-script-loader'
import request from 'superagent';
//import Card from 'react-credit-card'
import { stripeConfig, subscription_details } from '../../../config'
import classNames from 'classnames'
import { base } from '../../../config';
// import Button from '../Button';
// import Loader from '../Loader';
import Select from 'react-select';

export class PaymentForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            stripeLoading: true,
            stripeLoadingError: false,
            submitDisabled: false,
            paymentError: null,
            paymentComplete: false,
            token: null,
            inputValue: '',
            month: '',
            year: new Date().getFullYear(),
            name: '',
            csv: '',
            cvcFocused: null,
            user: null,
            readyToPay: false,
            checkingPaymentInfo: false,
            creatingYourAccess: false
        }
    };

    initEditor() {
        if (!PaymentForm.getStripeToken) {
            Stripe.setPublishableKey(stripeConfig.publishableKey);
            this.setState({ stripeLoading: false, stripeLoadingError: false });
        }
    }

    componentWillReceiveProps (nextProps) {
        if (nextProps.isScriptLoaded && !this.props.isScriptLoaded) {
            if (nextProps.isScriptLoadSucceed) {
                this.initEditor()
            }
        else {
                alert("error");
            }
        }
    }

    componentDidMount () {
        const { isScriptLoaded, isScriptLoadSucceed } = this.props;
        if (isScriptLoaded && isScriptLoadSucceed) {
            this.initEditor()
        }
    }

    onScriptError() {
        this.setState({ stripeLoading: false, stripeLoadingError: true });
    }

    updateInputValue(evt) {
        this.setState({
            inputValue: evt.target.value
        });
    }

    updateMonth(evt) {
        this.setState({
            month: evt.target.value
        });
    }

    updateName(evt) {
        this.setState({
            name: evt.target.value
        });
    }

    updateCsv(evt) {
        this.setState({
            csv: evt.target.value
        });
    }

    _setCvcFocues(focusBlur) {
        if (focusBlur) {
            this.setState({cvcFocused: "cvc"});
        } else {
            this.setState({cvcFocused: null});
        }
    }

    // _payStripe(id, amount) {
    //     const notify = this.props.notify;
    //     const finishedPayment = this.props.finishedPayment;
    //     if (this.props.email && this.props.uid ) {
    //         this.setState({ checkingPaymentInfo: false, creatingYourAccess: true });
    //         let parent = this;
    //         let data = {
    //             token: id,
    //             amount: amount,
    //             email: this.props.email,
    //             user_id: this.props.uid,
    //             payment_id: id,
    //             payment_plan: subscription_details.id,
    //             create_customer: true
    //         };
    //         request.post('https://3z4k770jic.execute-api.us-west-2.amazonaws.com/prod/signup')
    //         .send(data)
    //         .set('Accept', 'application/json')
    //         .end(function(err, res){
    //
    //             base.push('user_details/' + this.props.uid + '/payments', {
    //                 context: this,
    //                 data: res.body,
    //                 then(err){
    //                     if(!err){
    //                         parent.setState({ creatingYourAccess: false, paymentComplete: true });
    //                         finishedPayment('completed');
    //                         notify('account_info_updated', 2, 'state-change');
    //                     } else {
    //
    //                     }
    //                 }
    //             }, this);
    //         }.bind(this));
    //     } else {
    //         alert("There was a problem creating the payment");
    //     }
    // }

    _createStripeSubscription(res) {
        this.setState({ creatingYourAccess: false, paymentComplete: true, customerCreated: true });
        let parent = this;
        let data = {
            create_subscription: true,
            customer_id: res.body.id,
            payment_plan: subscription_details.payment_plan,
            user_id: this.props.uid
        };
        request.post('https://3z4k770jic.execute-api.us-west-2.amazonaws.com/prod/signup').send(data).set('Accept', 'application/json').end((err, res) => {
            if (err) {
                console.log(err);
            } else {
                base.post('user_details/' + this.props.uid + '/payments', { context: this, data: res.body, then(err) {
                    alert("Done");
                }}, this);
            }
        });
    }

    _createStripeCustomer(id, amount) {
        const notify = this.props.notify;
        const finishedPayment = this.props.finishedPayment;
        if (this.props.email && this.props.uid ) {
            this.setState({ checkingPaymentInfo: false, creatingYourAccess: true });
            let parent = this;
            let data = {
                create_customer: true,
                token: id,
                amount: amount,
                email: this.props.email,
                user_id: this.props.uid,
                payment_id: id
            };
            request.post('https://3z4k770jic.execute-api.us-west-2.amazonaws.com/prod/signup').send(data).set('Accept', 'application/json').end((err, res) => {
                if (err) {
                    console.log(err);
                } else {
                    base.post('user_details/' + this.props.uid + '/customer', { context: this, data: res.body, then(err) {
                        parent._createStripeSubscription(res);
                    }}, this);
                }
            });
        } else {
            alert("There was a problem creating the payment");
        }
    }

    onSubmit(event) {
        var self = this;
        this.props.finishedPayment(true);
        event.preventDefault();
        this.setState({ submitDisabled: true, paymentError: null, checkingPaymentInfo: true, creatingYourAccess: false });
        Stripe.createToken(event.target, function(status, response) {
            if (response.error) {
                self.setState({ paymentError: response.error.message, submitDisabled: false, checkingPaymentInfo: false });
            } else {
                self.setState({ submitDisabled: false, token: response.id });
                this._createStripeCustomer(response.id, 300);
            }
        }.bind(this));
    }

    updateYear(index) {
        console.log(index);
        this.setState({year: index});
    }

    render() {

        const options = [
            { value: new Date().getFullYear(), label: new Date().getFullYear()},
            { value: new Date().getFullYear() + 1, label: new Date().getFullYear() + 1},
            { value: new Date().getFullYear() + 2, label: new Date().getFullYear() + 2},
            { value: new Date().getFullYear() + 3, label: new Date().getFullYear() + 3},
            { value: new Date().getFullYear() + 4, label: new Date().getFullYear() + 4},
            // { value: new Date().getFullYear() + 5, label: new Date().getFullYear() + 5},
            // { value: new Date().getFullYear() + 6, label: new Date().getFullYear() + 6},
            // { value: new Date().getFullYear() + 7, label: new Date().getFullYear() + 7},
            // { value: new Date().getFullYear() + 8, label: new Date().getFullYear() + 8}
        ];

        if (this.state.stripeLoading) {
            return <div>Loading</div>;
        }
        else if (this.state.stripeLoadingError) {
            return <div>Error</div>;
        }

        else {

            let classes = classNames({
                'stripe-payments light-bg pad-lg': true
            });

            //Loader
            return (
                <div className={classes}>
                    { !this.state.paymentComplete &&
                        <div>

                            { !this.state.creatingYourAccess && !this.state.checkingPaymentInfo &&
                                <div className="">
                                    <div className="col-sm-12">
                                        <h4 className="stripe-secure pull-left">
                                          <img src="/assets/stripe.png"/>secure payments
                                        </h4>
                                        <img className="pull-right cards" width="150px" src="/assets/credit-cards.svg"/>
                                        <div className="clear"></div>
                                        <hr/>
                                    </div>
                                    <div className="col-sm-5">
                                        <div className="credit-card">

                                            <img className="padlock" src="/assets/padlock.png"/>
                                        </div>

                                        <p className="payments-enc small m-0 m-t-sm">Payments are encrypted and processed securely via Amazon Cloud and Stripe. We do not store any of your details on our server.</p>

                                    </div>
                                    <div className="col-sm-7">
                                        { this.state.paymentError &&
                                        <div className="row m-t-sm">
                                            <div className="col-xs-12">
                                                <span className="payment-errors">
                                                    <span>{ this.state.paymentError }</span>
                                                </span>
                                            </div>
                                        </div>
                                        }
                                        <form onSubmit={this.onSubmit.bind(this)}>
                                            <div className="row">
                                                <div className="col-xs-9">
                                                    <div className="form-group">
                                                        <label htmlFor="cardNumber">Card number</label>
                                                        <div className="input-group">
                                                           <input
                                                             type="text"
                                                             className="form-control"
                                                             data-stripe='number'
                                                             placeholder='Card Number (XXXX XXXX XXXX XXXX)'
                                                             value={this.state.inputValue}
                                                             onChange={this.updateInputValue.bind(this)}
                                                           />
                                                           <span className="input-group-addon"><i className="icon-lock"></i></span>
                                                         </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row m-t-sm">
                                                <div className="col-xs-3">
                                                    <div className="form-group">
                                                        <label htmlFor="cardExpiry">Expiry Month</label>


                                                        <div className="input-group">
                                                           <input
                                                             className="form-control"
                                                             type='text'
                                                             data-stripe='exp-month'
                                                             placeholder='MM'
                                                             value={this.state.month}
                                                             onChange={this.updateMonth.bind(this)}
                                                           />
                                                           <span className="input-group-addon"><i className="icon-calendar2"></i></span>
                                                         </div>

                                                    </div>
                                                </div>
                                                <div className="col-xs-3">
                                                    <div className="form-group">
                                                        <label htmlFor="cardExpiry">Expiry year</label>
                                                        <div className="">
                                                            <span>
                                                                <div className="btn-bg select-outer">
                                                                    <input
                                                                        className="hidden"
                                                                        type='text'
                                                                        data-stripe='exp-year'
                                                                        placeholder='YY'
                                                                        value={this.state.year} />
                                                                    <Select options={options} simpleValue clearable={false}  placeholder={false} name="selected-filter" value={this.state.year} onChange={this.updateYear.bind(this)} searchable={false} />
                                                                    <span className="icon-down-arrow"></span>
                                                                </div>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-xs-3">
                                                    <div className="form-group">
                                                        <label htmlFor="cardCVC">CSV code</label>


                                                        <div className="input-group">
                                                           <input
                                                             className="form-control"
                                                             onFocus={this._setCvcFocues.bind(this, true)}
                                                            onBlur={this._setCvcFocues.bind(this, false)}
                                                            type='text'
                                                            data-stripe='cvc'
                                                            placeholder='123'
                                                            name="cvc"
                                                            value={this.state.csv} onChange={this.updateCsv.bind(this)}
                                                           />
                                                           <span className="input-group-addon"><i className="icon-credit-card"></i></span>
                                                         </div>


                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row m-t-sm">
                                                <div className="col-xs-12">


                                                    <p className="small m-0 m-t-sm">You can cancel your subscription anytime by visiting My Account.</p>

                                                    <p className="m-0 m-t-sm"><span className="hidden-md">Undecided?</span> <a onClick={this.props.continue}>Continue exploring <strong>Pro</strong>Quotes <i className="icon-chevron-thin-right"></i></a></p>





                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            }
                        </div>
                    }
                </div>
            );
        }
    }
}

// <Card
//     cvc={this.state.csv}
//     number={this.state.inputValue}
//     name={"card details"}
//     expiry={this.state.month + this.state.year}
//     focused={this.state.cvcFocused}
// />

//Payments are securely made via Amazin cloud and Stripe. We do not keep your details on our servse and all payments are securely encrypted via SSL. You can cancel your account anytime in your account. {/*<a href="">Contact Us</a>*/}
//https://js.stripe.com/v2/
export default PaymentForm



// WEBPACK FOOTER //
// ./src/views/components/StripePayments/index.js